import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  rootPaymentDetails: {
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      '& .description': {
        width: '45%',
      },
    },
  },
  card: {
    fontFamily: theme.typography.proxima.regular,
    padding: 16,

    [theme.breakpoints.up('md')]: {
      padding: 24,
    },

    '& .policyLink': {
      float: 'right',
      display: 'flex',

      '& .title': {
        color: theme.palette.grey2,
        float: 'left',
        margin: '10px 0 0 0',
        padding: '12px 0 12px 12px',
        ...theme.rccl.labelSmall,
        letterSpacing: 'normal',
      },
      '& .MuiButtonBase-root.MuiButton-text': {
        paddingLeft: '5px',
      },

      [theme.breakpoints.down('xs')]: {
        display: 'block',
        float: 'none',
        textAlign: 'center',

        '& .title': {
          margin: '0',
          display: 'inline-block',
          float: 'none',
        },
        '& .MuiButtonBase-root.MuiButton-text': {
          width: 'auto',
          float: 'none',
        },
      },
    },

    '& .slideClose': {
      maxHeight: '0',
      overflow: 'hidden',
      transition: 'all .4s ease',
    },

    '& .slideOpen': {
      maxHeight: '1800px',
      overflow: 'hidden',
      transition: 'all 1s ease',
    },
  },

  balanceSection: {
    '& .isFourthColum': {
      [theme.breakpoints.down('lg')]: {
        marginTop: '24px',
        paddingTop: '24px',
        borderTop: `1px solid ${theme.palette.border}`,
      },
    },

    '&.noFullPayment': {
      '& > :first-child, & > :nth-child(2)': {
        paddingBottom: '24px',
      },
      '& > :nth-child(3), & > :nth-child(4)': {
        paddingTop: '24px',
        borderTop: `1px solid ${theme.palette.border}`,
      },
      [theme.breakpoints.up('xl')]: {
        '& > :first-child, & > :nth-child(2)': {
          paddingBottom: 0,
        },
        '& > :nth-child(3), & > :nth-child(4)': {
          paddingTop: 0,
          borderTop: 'none',
        },
      },
    },
    '& .subTitle': {
      margin: 0,
      fontWeight: 600,
      color: theme.palette.blue1,
      fontSize: theme.typography.pxToRem(14),
      [theme.breakpoints.up('md')]: {
        fontSize: theme.typography.pxToRem(16),
      },
    },
    '& .titleCH': {
      margin: '8px 0px 0px',
      fontWeight: 400,
      color: theme.palette.blue1,
      fontSize: theme.typography.pxToRem(14),
      textTransform: 'capitalize',
      [theme.breakpoints.up('md')]: {
        fontSize: theme.typography.pxToRem(16),
      },
    },
    '& .title': {
      margin: '8px 0px 0px',
      fontWeight: 600,
      color: theme.palette.blue1,
      fontSize: theme.typography.pxToRem(20),
      textTransform: 'capitalize',
      [theme.breakpoints.up('md')]: {
        fontSize: theme.typography.pxToRem(24),
      },
    },
    '& .footerTitle': {
      margin: 0,
      fontWeight: 400,
      color: theme.palette.blue1,
      fontSize: theme.typography.pxToRem(12),
    },
    '& .priceFooterTitle': {
      color: theme.palette.blue2,
      fontWeight: 600,
    },
  },

  footerBalanceSection: {
    display: 'flex',
    alignItems: 'end',
    marginTop: '24px',
    justifyContent: 'space-between',
    flexDirection: 'column-reverse',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
    '&.paymenHistory': {
      justifyContent: 'flex-end',
    },
    '&.brazilFooter': {
      width: '100%',
      [theme.breakpoints.only('md')]: {
        width: '85%',
      },
    },
    '& .paymentLittleMessage': {
      fontSize: theme.typography.pxToRem(12),
      color: theme.palette.gray1,
      margin: 0,
      lineHeight: 1,
      marginTop: '16px',
      width: '100%',
      [theme.breakpoints.only('md')]: {
        width: '70%',
        marginRight: '24px',
      },
      [theme.breakpoints.up('lg')]: {
        width: '65%',
        marginRight: '24px',
      },
      '& .dateStyles': {
        fontFamily: theme.typography.proxima.regular,
        textTransform: 'capitalize',
      },
    },
  },

  paymentButton: {
    float: 'right',
    lineHeight: '27px',
    height: 50,

    '& span': {
      [theme.breakpoints.between('md', 'lg')]: {
        fontSize: theme.typography.pxToRem(15),
        lineHeight: theme.typography.pxToRem(18),
      },
    },
  },
  paymentHistoryButton: {
    padding: 0,
    height: 'auto',
    '& span': {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 1,
      fontWeight: '600',
      color: theme.palette.blue2,
      [theme.breakpoints.between('md', 'lg')]: {
        fontSize: theme.typography.pxToRem(16),
        lineHeight: 1,
      },
    },
  },
  courtesyHoldView: {
    flexDirection: 'column',
    alignItems: 'flex-start !important',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
    '& div .viewPricing': {
      minWidth: 'fit-content',
      paddingBottom: '0',
    },
    '& .ch-link-wrapper': {
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: 'fit-content',
      },
    },
  },
  header: {
    '& .expand-more-icon svg': {
      marginLeft: '5px',
      width: '12px',
    },
    borderBottom: `solid 1px ${theme.palette.divider}`,
    display: 'flex',
    marginBottom: 30,
    paddingBottom: 20,
    alignItems: 'center',

    '& .title, & .viewPricing': {
      flexGrow: '1',
      fontFamily: theme.typography.proxima.regular,
    },
    '& .title': {
      fontFamily: theme.typography.proxima.semiBold,
      fontSize: theme.typography.pxToRem(24),
      lineHeight: '150%',
      color: theme.palette.blue1,
      marginBottom: 0,

      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(18),
      },
    },
    ' & .viewPricing': {
      paddingTop: '0px',
      color: theme.palette.blue2,
      cursor: 'pointer',
      display: 'inline-flex',
      textAlign: 'right',
      textDecoration: 'none',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(18),
      padding: '10px 0 10px',

      [theme.breakpoints.down('lg')]: {
        lineHeight: '150%',
      },

      [theme.breakpoints.only('xs')]: {
        maxWidth: '100px',
      },

      '& .hideLabel': {
        marginRight: '5px',
      },

      '& svg': {
        marginLeft: '5px',
        position: 'relative',
        top: '-3px',

        '& path:first-of-type': {
          fill: theme.palette.blue2,
        },
      },
    },

    [theme.breakpoints.between('md', 'lg')]: {
      marginBottom: '20px',
      paddingBottom: '20px',
    },
  },
  content: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '15px 30px',
    marginBottom: 20,

    [theme.breakpoints.down('lg')]: {
      padding: '15px 20px',
    },

    [theme.breakpoints.down('xs')]: {
      alignItems: 'baseline',
      marginBottom: '14px',
      '& .price': {
        paddingTop: theme.typography.pxToRem(16),
        fontSize: theme.typography.pxToRem(18),
        lineHeight: '150%',
        width: '50%',
      },
    },

    '& .title': {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '150%',
      marginTop: '0',
      color: theme.palette.blue1,
      marginBottom: 5,
    },

    '& .date': {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: '150%',
      color: theme.palette.grey1,
    },
    '& .price': {
      textAlign: 'right',
      fontSize: theme.typography.pxToRem(24),
      color: theme.palette.blue1,
      fontFamily: theme.typography.proxima.semiBold,

      [theme.breakpoints.down('md')]: {
        fontSize: theme.typography.pxToRem(20),
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.typography.pxToRem(18),
      },
    },
  },

  courtesyHoldContent: {
    flexDirection: 'column',
    marginBottom: '5px',
    padding: '22px 20px',
    [theme.breakpoints.up('md')]: {
      padding: '22px 30px',
      flexDirection: 'row',
    },
    '& .title': {
      marginBottom: 0,
      minWidth: 'fit-content',
    },
    '& .description, .price': {
      minWidth: 'fit-content',
    },
    '& .price': {
      fontSize: theme.typography.pxToRem(20),
      paddingTop: 0,
      [theme.breakpoints.up('md')]: {
        fontSize: theme.typography.pxToRem(24),
      },
    },
  },

  courtesyHoldPrice: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& .ch-price': {
      fontSize: theme.typography.pxToRem(20),
      color: theme.palette.blue1,
      [theme.breakpoints.up('md')]: {
        marginLeft: 'auto',
        fontSize: theme.typography.pxToRem(24),
      },
    },
    '& img': {
      width: '51px',
    },
    '& .prequalify': {
      [theme.breakpoints.up('md')]: {
        marginLeft: 'auto',
      },
    },
    '&:nth-of-type(1)': {
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.blue2,
    },
    '& .price': {
      fontSize: theme.typography.pxToRem(20),
    },
  },

  courtesyHoldWrapper: {
    marginBottom: '30px',
  },

  affirmContent: {
    padding: `15px 0px!important`,
    marginBottom: 20,
    display: 'flex',
    justifyContent: 'space-between',

    '& .price': {
      textAlign: 'right',
      fontSize: theme.typography.pxToRem(24),
      color: theme.palette.blue1,
      fontFamily: theme.typography.proxima.semiBold,

      [theme.breakpoints.down('md')]: {
        fontSize: theme.typography.pxToRem(20),
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.typography.pxToRem(18),
      },
    },

    '& .title': {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '150%',
      marginTop: '0',
      color: theme.palette.blue1,
      marginBottom: 5,
    },

    '& .date': {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: '150%',
      color: theme.palette.grey1,
    },
    '& .affirmText': {
      fontSize: theme.typography.pxToRem(14),
      fontFamily: theme.typography.proxima.regular,
      color: theme.palette.blue1,
      fontWeight: 400,
      '& > img': {
        maxHeight: 20,
        maxWidth: 50,
      },
      [theme.breakpoints.down('sm')]: {
        textAlign: 'right',
        fontSize: theme.typography.pxToRem(12),
        '& > img': {
          maxWidth: 45,
        },
      },
    },

    '& .affirmLink': {
      fontFamily: theme.typography.proxima.semiBold,
      fontStyle: 'normal',
      color: theme.palette.blue1,
      textAlign: 'left',
      fontSize: theme.typography.pxToRem(12),
      paddingTop: '4px',
      lineHeight: '14.4px',
      '& .affirm-as-low-as': {
        '& a': {
          textDecoration: 'none',
          color: theme.palette.blue1,
          display: 'block',
          '& .affirm-ala-price': {
            color: theme.palette.blue2,
          },
        },
      },
    },

    [theme.breakpoints.down('lg')]: {
      padding: '15px 20px',
    },

    [theme.breakpoints.down('xs')]: {
      alignItems: 'baseline',
      marginBottom: '14px',
      '& .price': {
        paddingTop: theme.typography.pxToRem(16),
        fontSize: theme.typography.pxToRem(18),
        lineHeight: '150%',
      },
    },
  },

  avoidScroll: {
    overflow: 'hidden!important',
  },

  modalDialog: {
    '& .MuiDialog-paper': {
      margin: 0,
      borderRadius: '4px',
      width: '100%',
      height: '100%',
      maxHeight: '100%',
      padding: '20px',
      [theme.breakpoints.up('sm')]: {
        margin: 20,
        maxWidth: '600px',
        maxHeight: '435px',
        padding: '56px 40px 56px 48px',
      },
      '&::-webkit-scrollbar': {
        borderRadius: '4px',
      },
    },
  },

  headerModal: {
    display: 'flex',
    justifyContent: 'space-between',
    '& .title': {
      fontSize: theme.typography.pxToRem(22),
      color: theme.palette.blue1,
      fontWeight: '600',
      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.pxToRem(24),
      },
    },
  },

  subHeaderModal: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '40px 0px 16px',
    '& .subtitle': {
      fontSize: theme.typography.pxToRem(18),
      color: theme.palette.blue1,
      fontWeight: '600',
    },

    [theme.breakpoints.up('sm')]: {
      paddingBottom: '24px',
      margin: '30px 0px 20px',
      borderBottom: `1px solid ${theme.palette.border}`,
      '& .subtitle': {
        fontSize: theme.typography.pxToRem(16),
        color: theme.palette.blue1,
        fontWeight: '600',
      },
    },
  },

  closeDialog: {
    color: theme.palette.blue2,
    height: 40,
    width: 40,
    right: '30px',
    top: '30px',
    cursor: 'pointer',
    [theme.breakpoints.down('lg')]: {
      height: 30,
      width: 30,
    },
    [theme.breakpoints.down('sm')]: {
      right: '20px',
    },
  },

  headerRow: {
    '& th': {
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.blue1,
      fontWeight: '600',
    },
    '& th:first-child': {
      padding: '10px 0px 10px 24px',
    },
    '& th:last-child': {
      padding: '10px 24px 10px 0px',
    },
  },

  dataRow: {
    '& .amount': {
      fontWeight: '600',
    },
    '& .status': {
      fontWeight: '600',
      color: theme.palette.successful,
      textAlign: 'center',
    },
    '& .iconHeader': {
      textAlign: 'center',
    },
    '& th': {
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.gray1,
    },
    '& th:first-child': {
      padding: '10px 0px 10px 24px',
    },
    '& th:last-child': {
      padding: '10px 24px 10px 0px',
    },
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.grey5,
    },
  },

  mobileTable: {
    '& > div:not(:last-child)': {
      marginBottom: '30px',
    },
    '& .rowContainer': {
      display: 'flex',
      justifyContent: 'space-between',
      '& > div:not(:last-child)': {
        marginBottom: '5px',
      },
    },
    '& .header': {
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.grey1,
      fontWeight: '600',
    },
    '& .paidText': {
      fontWeight: '600',
      color: theme.palette.successful,
    },
    '& .amount': {
      fontWeight: '600',
    },
    '& .total': {
      marginTop: '-14px',
      fontSize: theme.typography.pxToRem(20),
      color: theme.palette.blue1,
      fontWeight: '600',
    },
  },

  creditCarardIcon: {
    [theme.breakpoints.up('sm')]: {
      paddingRight: '10px',
    },
    '& svg': {
      width: '30px',
      height: '19px',
    },
  },

  desktopColumns: {
    [theme.breakpoints.only('xl')]: {
      display: 'flex',
      justifyContent: 'end',
    },
  },
  separator: {
    [theme.breakpoints.only('xl')]: {
      borderLeft: `1px solid ${theme.palette.border}`,
    },
  },
  affirmAnnounceWidth: {
    width: '135px',
  },
  mobileSpace: {
    [theme.breakpoints.down('sm')]: {
      paddingRight: '10px',
    },
  },
  mobileAligned: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'space-between',
    },
  },
}));

export default useStyles;
